// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__12U2K","disabled":"styles_disabled__HL9j4"};